<template>
  <div></div>
</template>
<script>
export default {
  beforeMount() {
    localStorage.removeItem("token");
    this.$router.push({ name: "Register" });
  },
};
</script>

<style></style>
